export const sourceMap = {
    whats_app: 'WhatsApp',
    gmail: 'Gmail',
    app: 'Magic Upload',
};

export enum HEADER_TITLE {
    ORGANISATION_NAME = 'Organisation Name',
    SOURCE = 'Source',
    UPLOADED_BY = 'Uploaded By',
    DATA_TYPE = 'Data Type',
    REQUESTED_BY = 'Sources',
}

export enum KEY_NAME {
    ASSESSEE_ORGID_LIST = 'assesseeOrgIdList',
    SOURCES = 'sources',
    USER_IDS = 'userIds',
    DATA_TYPES = 'dataTypes',
    REQUESTED_BY = 'requestedBy',
}
export const NEED_INFO = 'needInfo';
export const MAGIC_UPLOAD = 'magicUpload';
export const MAGIC_SIGN = 'magicSign';

export const CLARIFICATION_TYPE = {
    SYSTEM_GENERATED: 'SYSTEM_GENERATED',
    USER_GENERATED: 'USER_GENERATED',
};

export const REQ_SOURCE = ['LENDER_BASE_CONFIG', 'PNO_BASE_CONFIG'];
export const SHOW_AI_FOR = ['EMAIL_THREAD', 'MANUAL'];

export const MIME_TYPES = {
    rar: 'application/x-compressed',
    zip: 'application/zip',
    pdf: 'application/pdf',
    oct_stream: 'application/octet-stream',
};

export const WRITE = 'WRITE';

export const GLOBAL_SEARCH_GROUPS = {
    ALREADY_ADDED: 'alreadyAdded',
    ADD_NEW: 'addNew',
} as const;

export type GlobalSearchGroupKey = (typeof GLOBAL_SEARCH_GROUPS)[keyof typeof GLOBAL_SEARCH_GROUPS];

// Entity-search card kind, returned by BE on entity-search cards (e.g. two
// same-name results: a sole-proprietor entity vs. a pan-profile individual).
export const ENTITY_TYPE = {
    PERSON: 'PERSON',
    COMPANY: 'COMPANY',
} as const;

export type EntityType = (typeof ENTITY_TYPE)[keyof typeof ENTITY_TYPE];

// Labels for the AddNewPill chip that distinguishes same-name person cards.
export const ENTITY_PILL_LABEL = {
    SOLE_PROPRIETOR: 'Sole Proprietor',
    INDIVIDUAL: 'Individual',
} as const;
